import React, { useContext, useState, useRef } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ReCAPTCHA from "react-google-recaptcha";
import { ProjectContext } from "../../contexts/ProjectContext";
import { CommentData } from "../../data/commentData";
import CloseIcon from "@mui/icons-material/Close";
import { AuthContext } from "../../contexts/authContext";

const SignInButton = () => (
  <Button 
    href="/login" 
    variant="contained" 
    color="primary" 
    sx={{ borderRadius: 20 }}
  >
    Sign in
  </Button>
);

export const AddComment = ({ onOpen, onClose }) => {
  const [newElement, setNewElement] = useState(CommentData);
  const [errors, setErrors] = useState({ name: false, comment: false });
  const { addComment } = useContext(ProjectContext);
  const recaptchaRef = useRef(null);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const { user, userProfile } = useContext(AuthContext);

  const handleAdd = async () => {
    // Set user-related fields in the new comment element
    newElement.userid = user?.uid || "";
    newElement.name = userProfile?.name || "";
    newElement.userimage = userProfile?.picurl || "";
    newElement.createdon = new Date().toISOString();
    
    const hasErrors = {
      comment: !newElement.comment.trim(),
    };
    setErrors(hasErrors);

    if (!hasErrors.comment) {
      if (siteKey && recaptchaRef.current) {
        const token = await recaptchaRef.current.getValue();
        if (!token) {
          return;
        }
        recaptchaRef.current.reset();
      }
      addComment(newElement);
      onClose();
    }
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      onClose();
    }
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setNewElement((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  return (
    <Dialog
      open={onOpen}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
        },
      }}
      onClose={handleClose}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 2.5,
          pr: 2,
          pl: 3,
        }}
      >
        <Box>
          <Typography variant="h6" component="div">
            Write a comment
          </Typography>
        </Box>
        <IconButton aria-label="Close editor" onClick={handleClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: { xs: 2.5, sm: 3 }, pt: 0 }}>
        {user ? (
          <Stack spacing={2}>
            {/* <TextField
              size="small"
              required
              margin="none"
              name="name"
              label="Name"
              type="text"
              fullWidth
              value={newElement.name}
              onChange={handleChange}
              error={errors.name}
              helperText={
                errors.name ? "Name is required" : `${newElement.name.length}/40`
              }
              inputProps={{ maxLength: 40 }}
            /> */}
            <TextField
              size="small"
              multiline
              required
              rows={4}
              margin="none"
              name="comment"
              label="Comment"
              type="text"
              fullWidth
              value={newElement.comment}
              onChange={handleChange}
              error={errors.comment}
              helperText={
                errors.comment
                  ? "Comment is required"
                  : `${newElement.comment.length}/300`
              }
              inputProps={{ maxLength: 300 }}
            />
          </Stack>
        ) : (
          <Box sx={{ py: 3, textAlign: "center" }}>
            <Typography variant="body1" color="text.secondary">
              Sign in to write comments
            </Typography>
            <SignInButton />
          </Box>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          p: { xs: 2.5, sm: 3 },
          pt: 0,
          justifyContent: "flex-end",
          bgcolor: "background.default",
        }}
      >
        {user && siteKey && (
          <ReCAPTCHA ref={recaptchaRef} size="normal" sitekey={siteKey} />
        )}
        <Button
          onClick={onClose}
          variant="outlined"
          color="error"
          sx={{ borderRadius: 2, minWidth: 100 }}
        >
          Cancel
        </Button>
        {user ? (
          <Button
            onClick={handleAdd}
            variant="contained"
            color="success"
            startIcon={<AddIcon />}
            sx={{ borderRadius: 2, minWidth: 130 }}
            // disabled={!newElement.name.trim() || !newElement.comment.trim()}
            disabled={!newElement.comment.trim()}
          >
            Send
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};